<template>
  <div>
    <div class="new_message">
      <textarea
        v-model="message"
        class="form-control new_message_textarea"
        rows="2"
      />

      <button
        :disabled="disabled"
        class="btn btn-primary new_message_submit"
        @click="submit"
      >
        {{ trans('core.submit') }}
      </button>
    </div>
    <a
      href="#"
      @click="close"
    >{{ trans('core.close') }}</a>
  </div>
</template>

<script>

import Loader from '@/employees/components/Loader'

export default {
  name: 'CreateMessage',
  components: { Loader },
  props: {
    advise: {
      required: false,
    },
  },
  data () {
    return {
      message: '',
    }
  },
  computed: {
    disabled () {
      return this.message.trim() === ''
    },

  },
  mounted () {
  },
  methods: {
    submit () {
      const data = {
        message: this.message.trim(),
      }

      this.$store.dispatch('addReaction', { adviseId: this.advise.id, data: data }).then(() => {
        this.message = ''
      })
    },
    close () {
      this.$store.dispatch('completeAdvise', { adviseId: this.advise.id }).then(() => {
        this.message = ''
        this.$emit('closeAdvise')
      })
    },

  },

}

</script>

<style scoped lang="scss">
.new_message {
  display: flex;
  flex-direction: row;
  margin-top:20px;

  &__textarea {
    flex: 80%;
  }

  &__submit {
    flex: 20%;
  }
}
</style>
